import { render, staticRenderFns } from "./ConsultantResume.vue?vue&type=template&id=56d876ea&scoped=true&"
import script from "./ConsultantResume.vue?vue&type=script&lang=js&"
export * from "./ConsultantResume.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantResume.vue?vue&type=style&index=0&id=56d876ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d876ea",
  null
  
)

export default component.exports